import React from 'react';
import { createSvgIcon } from '@mui/material';

export const PartiallyPaid = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
    <path
      d="M0 0.44043V7.9357H6.18273C6.05092 7.51721 5.99101 7.09873 5.99101 6.68649H2.39641C2.39641 5.99942 1.86321 5.43728 1.1982 5.43728V2.93885C1.86321 2.93885 2.39641 2.38295 2.39641 1.68964H8.38742C8.38742 2.38295 8.92661 2.93885 9.58562 2.93885V2.97633C9.98702 2.97633 10.3884 3.05128 10.7838 3.18869V0.44043H0ZM5.39191 2.31425C4.37344 2.33299 3.59461 3.12623 3.59461 4.18806C3.59461 5.24989 4.37344 6.02441 5.39191 6.06188C5.61957 6.06188 5.85322 6.01191 6.07489 5.91822C6.23664 5.23116 6.50624 4.58157 7.17124 3.94447C7.09935 3.11374 6.34448 2.29551 5.39191 2.31425ZM11.1613 4.35671L8.84274 6.79267L8.03395 5.93696L7.18922 6.8239L8.83674 8.5603L12 5.2374L11.1613 4.35671Z"
      fill="#207A00"
    />
  </svg>,
  'PartiallyPaid',
);
